(() => {
  class FactoriesMap extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const header = document.querySelector('sticky-header');

      this.visibleFactories = ['mills', 'factories'];
      this.factoriesData = JSON.parse(this.querySelector('[data-locations]').innerHTML);
      this.cards = Array.from(this.querySelectorAll('[data-factory-card]'));
      this.customSelect = this.querySelector('[data-custom-select]');
      this.customSelectTrigger = this.querySelector('[data-custom-select-trigger]');
      this.customSelectOptionsContainer = this.querySelector('[data-custom-select-options]');
      this.reduceMapTrigger = this.querySelector('[data-reduce-map]');
      this.expandMapTrigger = this.querySelector('[data-expand-map]');
      this.mapContainer = this.querySelector('#map-container');
      this.mobileMapToggler = this.querySelector('[data-map-toggle]');
      this.markers = [];

      this.popupClickHandler = this.onPopupClick.bind(this);
      this.mouseEnterHandler = this.onMouseEnter.bind(this);
      this.mouseLeaveHandler = this.onMouseLeave.bind(this);
      this.customSelectKeyUpHandler = this.onCustomSelectKeyUp.bind(this);
      this.reduceMapHandler = this.onReduceMapClick.bind(this);
      this.expandMapHandler = this.onExpandMapClick.bind(this);
      this.optionChangeHandler = this.onOptionChange.bind(this);
      this.refreshMapSizeHandler = this.refreshMapSize.bind(this);
      this.toggleCustomSelectHandler = this.toggleCustomSelect.bind(this);
      this.openDetailsHandler = this.openDetails.bind(this);
      this.toggleMapHandler = this.toggleMap.bind(this);
      this.viewLocationHandler = this.viewLocation.bind(this);


      document.addEventListener('factories-map:open-popup', (evt) => {
        this.openPopup({handle: evt.detail.handle})
      })

      this.cards.forEach((card) => {
        card.addEventListener('mouseenter', this.mouseEnterHandler);
        card.addEventListener('mouseleave', this.mouseLeaveHandler);
        card.addEventListener('click', this.openDetailsHandler)
      })

      this.customSelect.addEventListener('keyup', this.customSelectKeyUpHandler);
      this.customSelectOptionsContainer.addEventListener('click', this.optionChangeHandler);
      this.customSelectTrigger.addEventListener('click', this.toggleCustomSelectHandler);
      this.reduceMapTrigger.addEventListener('click', this.reduceMapHandler);
      this.expandMapTrigger.addEventListener('click', this.expandMapHandler);
      this.mapContainer.addEventListener('transitionend', this.refreshMapSizeHandler);
      document.addEventListener('gridSelector:change', this.refreshMapSizeHandler);
      this.mobileMapToggler.addEventListener('click', this.toggleMapHandler);
      document.addEventListener('factoriesMap:viewLocation', this.viewLocationHandler)


      window.addEventListener('resize', () => {
        this.style.setProperty('--header-height', header.offsetHeight + "px");
      }, {passive: true})

      this.initMapView()
      this.style.setProperty('--header-height', header.offsetHeight + "px");

    }

    disconnectedCallback() {
      this.customSelect.removeEventListener('keyup', this.customSelectKeyUpHandler);
      this.customSelectOptionsContainer.removeEventListener('click', this.optionChangeHandler);
      this.customSelectTrigger.removeEventListener('click', this.toggleCustomSelectHandler);
      this.reduceMapTrigger.removeEventListener('click', this.reduceMapHandler);
      this.expandMapTrigger.removeEventListener('click', this.expandMapHandler);
      this.mapContainer.removeEventListener('transitionend', this.refreshMapSizeHandler);
      document.addEventListener('gridSelector:change', this.refreshMapSizeHandler);
      this.map.remove();
    }

    initMapView() {
      this.map = new L.map("map-container", {
        zoomControl: false,
        worldCopyJump: true,
      })
      .setView(this.factoriesData[0].location.split(','), 2);

      L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
        maxZoom: 19,
        attribution:
          '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      }).addTo(this.map);

      L.control.zoom({
        position: 'topright'
      }).addTo(this.map);

      this.factoriesData.forEach((factory) => {
        this.markers.push({
          handle: factory.handle,
          location: factory.location,
          type: factory.type,
          marker: new L.marker(factory.location.split(","), {
            icon: new L.DivIcon({
              className: "custom-map-label",
              popupAnchor: [12, -15],
              html: `
                <img class="custom-map-label__icon" src="${
                  factory.type == "factory"
                    ? this.dataset.factoryIcon
                    : this.dataset.millIcon
                }" alt="${factory.type} icon"/>
                <span class="custom-map-label__body">${factory.name}</span>
              `,
            }),
          })
            .on("mouseover", function (e) {
              if (!this.isPopupOpen()) {
                this.openPopup();
              }
            })
            .on("popupopen", (e) => {
              e.popup._container.querySelector('[data-content-handle]').addEventListener('click', this.popupClickHandler);
            })
            .on("popupclose", (e) => {
              e.popup._container.querySelector('[data-content-handle]').removeEventListener('click', this.popupClickHandler);
            })
            .bindPopup(`
              <div class="custom-map-popup__container" data-content-handle="${factory.handle}">
                <div class="custom-map-popup__image-container">
                  <img class="custom-map-popup__image" src="${factory.featured_image.src}" alt="${factory.featured_image.alt}"/>
                </div>
                <div class="custom-map-popup__body">
                  <h3 class="custom-map-popup__title">${factory.name}</h3>
                  <p class="custom-map-popup__excerpt">${factory.excerpt}</p>
                </div>
              </div>
              `,
              {
                maxWidth: "268",
              }
            )
        }
        );
      })

      this.factoryLayer = new L.MarkerClusterGroup({
        showCoverageOnHover: false,
        iconCreateFunction: (cluster) => {
          return this.customClusterIcon(cluster);
        }
      });

      this.millLayer = new L.MarkerClusterGroup({
        showCoverageOnHover: false,
        iconCreateFunction: (cluster) => {
          return this.customClusterIcon(cluster);
        }
      });

      this.markers.forEach(item => {
          if(item.type == 'factory') {
            this.factoryLayer.addLayer(item.marker)
          } else (
            this.millLayer.addLayer(item.marker)
          )
        })

      this.millLayer.addTo(this.map);
      this.factoryLayer.addTo(this.map);
    }

    onPopupClick(evt) {
      const factoryHandle = evt.currentTarget.dataset.contentHandle;
      const factoryData = this.factoriesData.find((factory) => {
        return factory.handle == factoryHandle;
      })

      this.dispatchDetailEvent(factoryData);
    }

    onOptionChange(evt) {
      const option = evt.target.parentElement;
      this.updateCustomSelectOption(option);
      this.closeCustomSelect();
      this.filterView(option)
    }

    openPopup({handle}) {
      const markerItem = this.markers.find((marker) => marker.handle = handle);
      this.map.panTo(markerItem.location.split(','), {
        animate: true,
      });

      setTimeout(() => {
        markerItem.marker.openPopup();
      }, 250);
    }

    customClusterIcon(cluster) {
      return new L.DivIcon({
      className: 'custom-cluster-icon',
      iconAnchor: [17, 37],
      html: `
        <svg width="37px" height="37px" viewBox="0 0 38 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
            <g id="Artboard1" transform="matrix(1,0,0,1,-381.138,-278.268)">
                <rect x="381.138" y="278.268" width="37.724" height="43.465" style="fill:none;"/>
                <clipPath id="_clip1">
                    <rect x="381.138" y="278.268" width="37.724" height="43.465"/>
                </clipPath>
                <g clip-path="url(#_clip1)">
                    <g transform="matrix(1,0,0,1,375.276,272.535)">
                        <path d="M43.724,23.222C43.724,38.702 33.883,42.904 24.862,49.465C16.661,43.724 6,37.163 6,24.042C6,15.021 14.445,6 24.862,6C35.279,6 43.724,14.56 43.724,23.222Z" style="fill:white;fill-rule:nonzero;"/>
                        <g transform="matrix(0.863648,0,0,0.863648,29.7001,10.2675)">
                            <text x="-12px" y="23px" style="font-family:var(--font-body-family); font-weight:bold; text-align: center; font-size:20px;">${cluster.getChildCount()}</text>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
        `,
      });
    }

    onMouseEnter(evt) {
      const card = evt.currentTarget;
      const markerHandle = card.dataset.factoryHandle;

      this.evtTimeout = setTimeout(() => {
        const markerObject = this.markers.find((markerObject) => {
          return markerObject.handle == markerHandle
        })

        this.map.flyTo(markerObject.location.split(","), 5, {
          animate: false,
        });

        setTimeout(() => {
          markerObject.marker.openPopup();
        }, 2);
      }, 600)
    }

    onMouseLeave(evt) {
      clearTimeout(this.evtTimeout);
    }

    toggleCustomSelect() {
      if(this.customSelectTrigger.ariaExpanded == 'false') {
        this.openCustomSelect();
      } else {
        this.closeCustomSelect();
      }
    }

    openCustomSelect() {
      this.customSelectTrigger.ariaExpanded = true;
      this.customSelectOptionsContainer.classList.add('is-visible');
      this.customSelectOptionsContainer.focus();
    }

    closeCustomSelect() {
      this.customSelectTrigger.ariaExpanded = false;
      this.customSelectOptionsContainer.classList.remove('is-visible');
      this.customSelectTrigger.focus();
    }

    customSelectDown() {
      const dropdownItems = Array.from(this.customSelectOptionsContainer.querySelectorAll("li"));
      const selectedIndex = dropdownItems.findIndex((loopItem) => {
        return loopItem.ariaSelected == "true";
      })

      if(selectedIndex < dropdownItems.length - 1) {
        this.updateCustomSelectOption(dropdownItems[selectedIndex + 1]);
        this.filterView(dropdownItems[selectedIndex + 1].dataset.value)
      }
    }

    customSelectUp() {
      const dropdownItems = Array.from(this.customSelectOptionsContainer.querySelectorAll("li"));
      const selectedIndex = dropdownItems.findIndex((loopItem) => {
        return loopItem.ariaSelected == "true";
      })

      if(selectedIndex >= 1) {
        this.updateCustomSelectOption(dropdownItems[selectedIndex - 1]);
        this.filterView(dropdownItems[selectedIndex - 1]);
      }
    }

    filterView(option) {
      const optionValue = option.dataset.value;
      const cardsContainer = Array.from(this.querySelectorAll('[data-cards-grid] li'));

      if(optionValue == "") {
        this.visibleFactories = ["mill", "factory"];
        this.customSelectTrigger.querySelector('#selected-text').textContent = 'Facility'
        this.map.addLayer(this.factoryLayer, this.millLayer);
      } else {
        this.visibleFactories = [optionValue];
        this.customSelectTrigger.querySelector('#selected-text').innerHTML = option.innerHTML;

        if(optionValue == 'mill') {
          this.map.removeLayer(this.factoryLayer);
          this.map.addLayer(this.millLayer)
        } else {
          this.map.addLayer(this.factoryLayer);
          this.map.removeLayer(this.millLayer)
        }
      }

      cardsContainer.forEach((cardContainer) => {
        if(this.visibleFactories.includes(cardContainer.dataset.type)) {
          cardContainer.style.display = "block";
        } else {
          cardContainer.style.display = "none";
        }
      })

    }

    updateCustomSelectOption(option) {
      const dropdownItems = Array.from(this.customSelectOptionsContainer.querySelectorAll("li"));

      dropdownItems.forEach((loopItem) => {
        loopItem.setAttribute('aria-selected', false);
      })

      option.setAttribute('aria-selected', true);
      this.customSelectTrigger.setAttribute('aria-activedescendant', option.id);
    }

    onCustomSelectKeyUp(evt) {
      evt.preventDefault();

      switch(evt.key) {
        case "ArrowUp":
          if(this.customSelectTrigger.ariaExpanded == "false") {
            this.openCustomSelect();
          } else {
            this.customSelectUp();
          }
        break;

        case "ArrowDown":
          if(this.customSelectTrigger.ariaExpanded == "false") {
            this.openCustomSelect();
          } else {
            this.customSelectDown();
          }
        break;

        case "Escape":
          if(this.customSelectTrigger.ariaExpanded == "true") {
            this.closeCustomSelect();
          }
        break;

        case " ":
        case "Enter":
          this.toggleCustomSelect();
        break;
      }
    }

    onReduceMapClick() {
      this.classList.remove('map-expanded');
    }

    onExpandMapClick() {
      this.classList.add('map-expanded')
    }

    toggleMap() {
      this.classList.toggle('map-expanded');
    }

    refreshMapSize() {
      this.map.invalidateSize();
    }

    openDetails(evt) {
      const factoryHandle = evt.currentTarget.dataset.factoryHandle;
      const factoryData = this.factoriesData.find((factory) => {
        return factory.handle == factoryHandle;
      })

      this.dispatchDetailEvent(factoryData);
    }

    dispatchDetailEvent(data) {
      document.dispatchEvent(new CustomEvent('factoryMillDetail:open', {detail: {
        factoryData: data
      }}))
    }

    viewLocation(evt) {
      const factoryHandle = evt.detail.handle;
      const markerObject = this.markers.find((markerObject) => {
        return markerObject.handle == factoryHandle;
      })

      this.map.flyTo(markerObject.location.split(","), 5, {
        animate: false
      })

      setTimeout(() => {
        markerObject.marker.openPopup();
      }, 2);

      this.classList.add('map-expanded');
    }
  }

  if(!customElements.get('factories-map')) {
    customElements.define('factories-map', FactoriesMap);
  }
})()